import(/* webpackMode: "eager" */ "/var/directorder/app/staging/apps/buyer/src/app/layout.js");
